import {SuggestionStates, type Suggestion, type SuggestionState} from '../../../conversation-types'
import {
  AutomatedReviewSuggestionApplied,
  AutomatedReviewSuggestionError,
  AutomatedReviewSuggestionOutdated,
  AutomatedReviewSuggestionPending,
  AutomatedReviewSuggestionPresent,
} from './AutomatedReviewSuggestionStates'

export interface AutomatedReviewSuggestionProps {
  automatedCommentId: string
  basePath: string
  commentAuthorLogin?: string
  commentTitle?: string
  feedbackOptions?: Array<{label: string; value: string}>
  suggestion?: Suggestion
  suggestionState?: SuggestionState
}

const SuggestionStateComponents = {
  [SuggestionStates.Pending]: AutomatedReviewSuggestionPending,
  [SuggestionStates.Error]: AutomatedReviewSuggestionError,
  [SuggestionStates.Outdated]: AutomatedReviewSuggestionOutdated,
  [SuggestionStates.Applied]: AutomatedReviewSuggestionApplied,
  [SuggestionStates.Present]: AutomatedReviewSuggestionPresent, // Default suggestion component
} as const

export function AutomatedReviewSuggestion({
  automatedCommentId,
  basePath,
  commentAuthorLogin,
  commentTitle,
  feedbackOptions,
  suggestion,
  suggestionState,
}: AutomatedReviewSuggestionProps) {
  if (!suggestionState || suggestionState === SuggestionStates.NoSuggestion) {
    return null
  }

  const SuggestionComponent = SuggestionStateComponents[suggestionState]

  if (!SuggestionComponent) {
    return null
  }

  return (
    <SuggestionComponent
      automatedCommentId={automatedCommentId}
      basePath={basePath}
      commentTitle={commentTitle}
      commentAuthorLogin={commentAuthorLogin}
      feedbackOptions={feedbackOptions}
      suggestion={suggestion}
    />
  )
}
